import { CourseService } from '../../Services/course.service';
import { ToastyService } from 'ng2-toasty';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { GroupService } from '../../Services/group.service';

@Component({
  selector: 'app-group-form',
  template: require('./group-form.component.html'),
  styles: [require('./group-form.component.css')]
})
export class GroupFormComponent implements OnInit {

  group: any = {};
  categories: any[] = [];

  constructor(private router: Router,
    private route: ActivatedRoute,
    private groupService: GroupService,
    private courseService: CourseService,
    private toastyService: ToastyService) {

    route.params.subscribe(p => {
      if (p['id'])
        this.group.id = +p['id'];
      else
        this.group.id = 0;
    });


  }

  ngOnInit() {
    if (this.group.id > 0) {
      this.groupService.getGroup(this.group.id).subscribe(
        g => {
          this.group = g;
          console.log(this.group);
        }, err => {
          if (err.status == 404)
            // this.router.navigate(['/home']);
            console.log(err);
            console.log(this.group.id);
        });
      }
      this.courseService.getCourseCategories().subscribe( (x:any) =>{
        this.categories = x;
        // console.log(this.categories);
        
      });
  }

  submit() {
    if (this.group.id) {
      this.groupService.update(this.group).subscribe(x => {
        // console.log("save of group done: "+ x);
        this.router.navigate(['/groups/list']);
      });
    }
    else {
      this.groupService.create(this.group).subscribe(x => {
        // console.log(x);
        this.router.navigate(['/groups/list']);
      });
    }
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/group-form/group-form.component.ts